import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { GetContactsForBorrower } from 'app/store/contact/contact.actions';
import { GetBorrowerValues } from 'app/store/borrower-value/borrower-value.actions';
import { GetBorrower } from 'app/store/borrower/borrower/borrower.actions';
import { GetNonOwnerPersonnelForBorrower } from 'app/store/non-owner-personnel/non-owner-personnel.actions';

@Component({
  selector: 'app-borrower-contact-methods',
  templateUrl: 'borrower-contact-methods.component.html',
  styleUrls: ['./borrower-contact-methods.component.scss']
})
export class BorrowerContactMethodsComponent implements OnInit {

  @Input() borrowerId: number;
  @Input() borrowerStatus: string;
  @Input() hideCallButton: boolean = false;
  @Input() hideSmsButton: boolean = false;
  @Input() hideEmailButton: boolean = false;


  constructor(
    private store: Store
  ) { }

  ngOnInit(){
    this.store.dispatch(new GetBorrower(this.borrowerId, false, false));
    this.store.dispatch(new GetBorrowerValues(this.borrowerId));
    this.store.dispatch(new GetContactsForBorrower(this.borrowerId));
    this.store.dispatch(new GetNonOwnerPersonnelForBorrower(this.borrowerId));
  }

}
